export const iconList = [
  "FaHome",
  "FaEarlybirds",
  "FaFly",
  "FaFortAwesome",
  "FaGetPocket",
  "FaReadme",
  "FaRedhat",
  "FaSketch",
  "FaStickerMule",
  "FaUps",
  "FaBaby",
  "FaBath",
  "FaBed",
  "FaBeer",
  "FaBiking",
  "FaBirthdayCake",
  "FaBlender",
  "FaBook",
  "FaBug",
  "FaBus",
  "FaCalculator",
  "FaCamera",
  "FaCar",
  "FaCat",
  "FaCheese",
  "FaTrashAlt",
  "FaTruckMoving",
  "FaTshirt",
  "FaTv",
  "FaUtensils",
];
